<div class="d-flex flex-column flex-root">
  <div class="d-flex flex-row flex-column-fluid page">
    <div class="d-flex flex-column flex-row-fluid wrapper" id="kt_wrapper">
      <div class="content  d-flex flex-column flex-column-fluid" id="kt_content">
        <div class="d-flex flex-column-fluid">
          <div class=" container ">
            <div class="row">
              <div class="col-md-6">
                <div class="card card-custom gutter-b example example-compact">
                  <div class="card-header">
                    <h3 class="card-title">
تماس با ما                    </h3>
                    <div class="card-toolbar">
                      <div class="example-tools justify-content-center">
                      </div>
                    </div>
                  </div>
                  <!--begin::Form-->
                  <form class="text-right">
                    <div class="card-body">
                      <div class="form-group mb-8">
                        <div class="alert alert-custom alert-default" role="alert">
                          <div class="alert-icon"><span class="svg-icon svg-icon-primary svg-icon-xl">
                            <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" x="0px"
                                 y="0px"
                                 viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
                            <path style="fill:#3B4145;" d="M322.939,62.642l178.737,309.583C508.231,383.578,512,396.74,512,410.791
                              c0,42.67-34.592,77.264-77.264,77.264H256L194.189,256L256,23.946C284.62,23.946,309.587,39.519,322.939,62.642z"/>
                            <path style="fill:#525A61;" d="M189.061,62.642L10.323,372.225C3.769,383.578,0,396.74,0,410.791
                              c0,42.67,34.592,77.264,77.264,77.264H256V23.946C227.38,23.946,202.413,39.519,189.061,62.642z"/>
                            <path style="fill:#FFB751;" d="M474.913,387.678L296.177,78.098c-8.056-13.959-22.849-22.767-38.848-23.22l152.869,402.275h24.539
                              c25.559,0,46.358-20.798,46.358-46.358C481.095,402.677,478.952,394.683,474.913,387.678z"/>
                            <path style="fill:#FFD764;" d="M444.853,387.678c3.492,7.005,5.336,14.999,5.336,23.117c0,25.559-17.935,46.358-39.992,46.358
                              H77.264c-25.559,0-46.358-20.799-46.358-46.358c0-8.118,2.143-16.112,6.181-23.117l178.736-309.58
                              c8.283-14.34,23.674-23.251,40.177-23.251c0.443,0,0.886,0.01,1.329,0.031c13.732,0.536,26.414,9.323,33.326,23.22L444.853,387.678z
                              "/>
                            <path style="fill:#3B4145;" d="M256,354.131v51.509c14.227,0,25.755-11.528,25.755-25.755
                              C281.755,365.659,270.227,354.131,256,354.131z"/>
                            <path style="fill:#525A61;" d="M256,354.131c2.843,0,5.151,11.528,5.151,25.755c0,14.227-2.308,25.755-5.151,25.755
                              c-14.227,0-25.755-11.528-25.755-25.755C230.245,365.659,241.773,354.131,256,354.131z"/>
                            <path style="fill:#3B4145;" d="M256,132.646V323.23c14.227,0,25.755-11.538,25.755-25.755V158.401
                              C281.755,144.174,270.227,132.646,256,132.646z"/>
                            <path style="fill:#525A61;" d="M256,132.646c2.843,0,5.151,11.528,5.151,25.755v139.074c0,14.216-2.308,25.755-5.151,25.755
                              c-14.227,0-25.755-11.538-25.755-25.755V158.401C230.245,144.174,241.773,132.646,256,132.646z"/>
                              <g>
                              </g>
                              <g>
                              </g>
                              <g>
                              </g>
                              <g>
                              </g>
                              <g>
                              </g>
                              <g>
                              </g>
                              <g>
                              </g>
                              <g>
                              </g>
                              <g>
                              </g>
                              <g>
                              </g>
                              <g>
                              </g>
                              <g>
                              </g>
                              <g>
                              </g>
                              <g>
                              </g>
                              <g>
                              </g>
                              </svg>
                          </span></div>
                          <div class="alert-text">
                            <span class="text-right">در ساخت وب سایت دقت کنید</span><br>
                            به صورت پیش فرض هر کاربر می تواند یک وب سایت داشته باشد ولی در چندین سایت کاربر یاشد
                          </div>
                        </div>
                      </div>
                      <div *ngIf="dataModelResultDepartemen && dataModelResultDepartemen.isSuccess " class="form-group set-select">
                        <label for="webType">Departemen</label>
                        <select [(ngModel)]="dataModel.linkTicketingDepartemenId" name="linkTicketingDepartemenId" class="form-control" >
                          <option *ngFor="let item of dataModelResultDepartemen.listItems; index as i;" value="{{item.id}}"  [attr.selected]="i==0 ? 'selected' : null" >{{item.title}}</option>
                        </select>
                      </div>
                      <div class="form-group">
                        <label>FullName </label>
                        <input [(ngModel)]="dataModel.fullName" name="FullName" type="text" class="form-control"/>
                      </div>
                      <div class="form-group">
                        <label>PhoneNo </label>
                        <input [(ngModel)]="dataModel.phoneNo" name="PhoneNo" type="text" class="form-control"/>
                      </div>
                      <div class="form-group">
                        <label>Email </label>
                        <input [(ngModel)]="dataModel.email" name="Email" type="Email" class="form-control"/>
                      </div>

                      <div class="form-group mb-1">
                        <label for="description">description</label>
                        <textarea [(ngModel)]="dataModel.htmlBody" name="Description" class="form-control resize-none" id="description" rows="3"></textarea>
                      </div>
                    </div>

                    <img src="{{ captchaModel.image }}" (click)="onCaptchaOrder()"/>
                    <input [(ngModel)]="dataModel.captchaText" type="captchaText" name="captchaText"
                           #captchaTextGet="ngModel" autocomplete="off" class="form-control input-ntk mb-3"
                           placeholder="محتوای عکس امنیتی" required/>
                    <div *ngIf="captchaTextGet.invalid && (captchaTextGet.dirty || captchaTextGet.touched) "class="alert alert-danger">
                      <div *ngIf="captchaTextGet.errors.required">
                        محتوای عکس امنیتی is required.
                      </div>
                    </div>
                    <div class="card-footer">
                      <button (click)="onFormSubmit()" type="submit" class="btn btn-primary mr-2 w-70px">Send</button>
                      <button [routerLink]="'../'"  type="reset" class="btn btn-secondary w-70px">Cancell</button>
                    </div>
                  </form>
                  <!--end::Form-->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
